import React, { FunctionComponent } from "react"

const NoPermission: FunctionComponent = () => {
  return (
    <div className="no-permission-wrap">
      <span>No permission for this page.</span>
    </div>
  )
}

export default NoPermission
